import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DashboardService,  LocationServiceDto, InTransitDto, BlackboxService, JourneyItemDto, ActiveDashboardResponse, LocationTypeDto, ActiveDashboardRequest, DepotDto } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import moment from 'moment';
import { SummaryDataItemModel } from '../models/summary-data-item-model';
import { SessionStorageService } from '../services/session-storage.service';
import { DashboardMode } from '../dashboard-live/dashboard-live.component';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AuthService } from '../security/auth.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { PagingModel } from '../widgets/models/paging-model';
import { InTransitMapComponent } from '../widgets';

export class DropDownListItem {
  id: string;
  name: string;
}

@Component({
    selector: 'app-dashboard-active-component',
    templateUrl: './dashboard-active.component.html',
    styleUrls: ['./dashboard-active.component.scss'],
    standalone: false
})
export class DashboardActiveComponent extends PagebaseComponent implements OnDestroy, OnInit {

  // Private variables
  jobs: JourneyItemDto[]
  pagedJobs: JourneyItemDto[]
  services: LocationServiceDto[]
  inTransit: InTransitDto[];
  locationTypes: LocationTypeDto[] = [{ name: "Customer", id: "", classification: 0, colour: "#00c07f" }, { name: "Depot", id: "", classification: 0, colour: "#2978ff" }];
  selectedCustomerId: string;
  selectedVehicleId: string[];
  selectedLocationId: string[];
  selectedDepotId: string[];
  selectedVehicleType: null;
  maxDate: Date = new Date();
  selectedStartDate: Date;
  selectedEndDate: Date;
  summaryData = [];

  customerVehicles: DropDownListItem[];
  customerLocations: DropDownListItem[];
  depots: DropDownListItem[];
  irregularMovements: boolean = this.authService.isHeadOfficeUser();
  dashboardMode: DashboardMode = DashboardMode.Normal;
  DashboardMode = DashboardMode;
  jobsPaging: PagingModel;
  private apiCall;
  viewModeForm = new UntypedFormGroup({
    viewMode: new UntypedFormControl('both')
  });
  showMode: string = "both";
  @ViewChild('inTransitMap') inTransitMap: InTransitMapComponent;
  
  // Public variables
  loading: boolean = true;

  // Constuctor
  constructor(
    private _dashboardService: DashboardService,
    private blackboxService: BlackboxService,
    private sessionStorageService: SessionStorageService,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService,
    private customerSettings: CustomerSettings) {
    super(pageHelperService, applicationStatusService, customerSettings, "Active Operations");
  }

  ngOnInit(): void {
      this.summaryData = this.getLoadingSummarries();
      this.setupDemoDate();
  }

  setupDemoDate(): void {
    var demoDate = this.customerSettings.getUISetting("UI-DemoDate", "");

    
    if (demoDate !== '') {
      var d = new Date(demoDate.replace(/['"]+/g, ''))
      this.sessionStorageService.setItem("dashboard-active-selectedStartDate", d.valueOf().toString())
      this.sessionStorageService.setItem("dashboard-active-selectedEndDate", d.valueOf().toString())
      this.selectedStartDate = d;
      this.selectedEndDate = d;
      this.maxDate = d;
    }
  }
  getLoadingSummarries() : SummaryDataItemModel[] {
    var items = [];
    var text = "";
    text = text.concat("\xa0");
    let blank: SummaryDataItemModel = {
      Title: text,
      Value: text
    };
    items.push(blank);
    items.push(blank);
    items.push(blank);
    return items;
  }

  ngOnDestroy() {
    this.unsubscribe()
  }

  unsubscribe() {
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  reset() {
    this.inTransit = [];
    this.jobs = [];
    this.services = [];
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }
  // Get the view data
  getData() {

    this.loading = true;
    this.setIsLoading(this.loading);
    var params = this.GetActiveDashboardRequest();
    this.apiCall = this._dashboardService.getActiveDashBoardData(
      params
    ).subscribe(data => {
      this.locationTypes = data.locationTypes;
      this.jobs = data.jobs;
      this.getJobsPaging();
      this.services = data.services;
      this.inTransit = this.generateVehicleLocations(this.jobs);
      this.summaryData = this.getSummaryData(data.milesDriven, data.numberOfServices, data.numberOfJobs)
      this.depots = this.getDepotList(data.depots);
      this.loading = false;
      this.loadListData(data);
      this.setIsLoading(this.loading);
    }, error => {
      debugger;
    });
  }

  getJobsPaging(){ 
    var currentPage = 1
    var pageSize = 10;
    var hasNext = false
    var hasPrevious = false

    var totalPages = this.jobs.length / pageSize

    if(totalPages > currentPage){
      hasNext = true
    }
    if(totalPages > 1){
      hasPrevious = true
    }

    this.jobsPaging = new PagingModel(currentPage,hasNext,hasPrevious,pageSize,totalPages, this.jobs.length)
  }

  dropdownChanged(opened) {
    if (!opened) {
      this.getData();
    }
  }

  vehicleChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleId")
    }
  }

  locationChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("dashboard-active-selectedLocationId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("dashboard-active-selectedLocationId")
    }
  }

  depotChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("dashboard-active-selectedDepotId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("dashboard-active-selectedDepotId")
    }
  }

  selectedEndDateChange(startDate, endDate) {
    if (startDate.value && endDate.value) {
      var startMoment = moment(startDate.value, 'DD/MM/YYYY');
      var endMoment = moment(endDate.value, 'DD/MM/YYYY');
      startDate = startMoment.toDate();
      endDate = endMoment.toDate();

      var utcStart = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0));
      this.sessionStorageService.setItem("dashboard-active-selectedStartDate", utcStart.valueOf().toString());
      console.log(startDate)
      console.log(this.selectedStartDate)

      var utcEnd = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0));
      this.sessionStorageService.setItem("dashboard-active-selectedEndDate", utcEnd.valueOf().toString());
      console.log(endDate);
      console.log(this.selectedEndDate);


      // Rset vehicle and location filters
      this.selectedVehicleId = [];
      this.selectedLocationId = [];
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleId")
      this.sessionStorageService.removeItem("dashboard-active-selectedLocationId")

      this.getData();
    }
  }

  selectedVehicleTypeValueChange(event) {
    this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(event));
    this.selectedVehicleType = event;
    this.getData();
  }

  getDateFromValue(newValue) {
    if (newValue == null) {
      var now = new Date();
      return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0));
    }

    if (newValue && newValue != null) {
      var milliseconds = newValue;
      newValue = new Date(0);
      newValue.setUTCMilliseconds(milliseconds)
    } else {
      newValue = new Date();
    }

    return new Date(Date.UTC(newValue.getFullYear(), newValue.getMonth(), newValue.getDate(), 0, 0, 0));
  }


  loadListData(data: ActiveDashboardResponse) {
    // Get list data from the provided data
    const vehicles: DropDownListItem[] = [];
    const locations: DropDownListItem[] = [];

    data.jobs.forEach(job => {
      // Add locations
      if (job.fromLocationId != null) {
        if (!locations.find(l => l.id == job.fromLocationId)) {
          var location = new DropDownListItem()
          location.id = job.fromLocationId;
          location.name = job.fromLocation;
          locations.push(location)
        }
      }

      if (job.toLocationId != null) {
        if (!locations.find(l => l.id == job.toLocationId)) {
          var location = new DropDownListItem()
          location.id = job.toLocationId;
          location.name = job.toLocation;
          locations.push(location)
        }
      }

      // Add vehicles
      if (job.vehicleId != null) {
        if (!vehicles.find(l => l.id == job.vehicleId)) {
          var vehicle = new DropDownListItem()
          vehicle.id = job.vehicleId;
          vehicle.name = job.vehicleName;
          vehicles.push(vehicle)
        }
      }

    });

    data.services.forEach(service => {
      // Add locations
      if (service.locationId != null) {
        if (!locations.find(l => l.id == service.locationId)) {
          var location = new DropDownListItem()
          location.id = service.locationId;
          location.name = service.locationName;
          locations.push(location)
        }
      }

      // Add vehicles
      if (service.vehicleId != null) {
        if (!vehicles.find(l => l.id == service.vehicleId)) {
          var vehicle = new DropDownListItem()
          vehicle.id = service.vehicleId;
          vehicle.name = service.vehicleName;
          vehicles.push(vehicle)
        }
      }
    });

    this.customerVehicles = vehicles.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.customerLocations = locations.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.setIrregularMovements();

    var selectedVehicleId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedVehicleId")) {
      selectedVehicleId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleId"));
      this.selectedVehicleId = selectedVehicleId;
    }
    var selectedLocationId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedLocationId")) {
      selectedLocationId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedLocationId"));
      this.selectedLocationId = selectedLocationId;
    }

    console.log(this.selectedVehicleId);
  }

  setIrregularMovements() {
    var sessionItem = this.sessionStorageService.getItem("dashboard-active-irregularMovements");
    if (sessionItem) {
      this.irregularMovements = (sessionItem === 'true');
    }
  }

  getDepotList(depots: DepotDto[]): DropDownListItem[] {
    const depotlist: DropDownListItem[] = [];
    depots.forEach(element => {
      var depot = new DropDownListItem()
      depot.id = element.id;
      depot.name = element.name;
      depotlist.push(depot)
    });

    return depotlist;
  }

  generateVehicleLocations(jobs: JourneyItemDto[]): InTransitDto[] {

    const data: InTransitDto[] = [];

    jobs.forEach(job => {
      const item: InTransitDto = {
        vehicleId: job.vehicleId,
        vehicleName: job.vehicleName,
        fromLocationId: job.fromLocationId,
        fromLocationLatitude: job.fromLocationLatitude,
        fromLocationLongitude: job.fromLocationLongitude,
        fromLocationName: job.fromLocation,
        fromLocationTypeName: job.fromLocationTypeName,
        toLocationId: job.toLocationId,
        toLocationLatitude: job.toLocationLatitude,
        toLocationLongitude: job.toLocationLongitude,
        toLocationName: job.toLocation,
        toLocationTypeName: job.toLocationTypeName,
        alert: job.alert
      }

      data.push(item);
    });

    return data;
  }

  changeIrregularMovements(value) {
    this.reset();
    this.irregularMovements = value;
    this.sessionStorageService.setItem("dashboard-active-irregularMovements", this.irregularMovements.toString());
    this.getData();
  }

  getSummaryData(milesValue: number, servicesValue: number, jobsValue: number): SummaryDataItemModel[] {
    var items = [];
    let miles: SummaryDataItemModel = {
      Title: "Miles Driven",
      Value: Math.trunc(milesValue).toString()
    };
    items.push(miles);
    let services: SummaryDataItemModel = {
      Title: "Services",
      Value: servicesValue.toString()
    };
    items.push(services);
    let jobs: SummaryDataItemModel = {
      Title: "Journeys",
      Value: jobsValue.toString()
    };
    items.push(jobs);
    return items;
  }

  exportJobsCSV() {
    this.loading = true;
    this.setIsLoading(this.loading);
    var params = this.GetActiveDashboardRequest();

    this.apiCall = this._dashboardService.getJobsFromMovementsOnDay(
      params
    ).subscribe(data => {
      this.loading = false;
      this.setIsLoading(this.loading);
      let filename = data.fileName;
      let blob: Blob = data.data;
      let a = document.createElement('a');
      a.download = filename;
      a.href = window.URL.createObjectURL(blob);
      a.click();
    }, error => {
      debugger;
    });
  }

  exportCustomerServicesCSV() {
    this.loading = true;
    this.setIsLoading(this.loading);
    var params = this.GetActiveDashboardRequest();

    this.apiCall = this._dashboardService.getCustomerServicesOnDate(
      params
    ).subscribe(data => {
      this.loading = false;
      this.setIsLoading(this.loading);
      let filename = data.fileName;
      let blob: Blob = data.data;
      let a = document.createElement('a');
      a.download = filename;
      a.href = window.URL.createObjectURL(blob);
      a.click();
    }, error => {
      debugger;
    });
  }

  changeJobsPage(self: any, page: number) {
    self.locationDetailsService.getLocationJourneys(self.locationId, self.pageHelperService.selectedCompanyId, 10, page).subscribe(data => 
      {
        self.jobs = data.items;
        self.jobsPaging = new PagingModel(data.currentPage, data.hasNext, data.hasPrevious, data.pageSize, data.totalPages, data.totalTotalItemCount);
      });

      this.pagedJobs
  }

  GetActiveDashboardRequest() {
    var selectedStartDate = this.getDateFromValue(this.sessionStorageService.getItem("dashboard-active-selectedStartDate"));
    this.selectedStartDate = selectedStartDate;

    var selectedEndDate = this.getDateFromValue(this.sessionStorageService.getItem("dashboard-active-selectedEndDate"));
    this.selectedEndDate = selectedEndDate;

    this.setIrregularMovements();

    var selectedVehicleId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedVehicleId")) {
      selectedVehicleId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleId"));
      this.selectedVehicleId = selectedVehicleId;
    }
    var selectedLocationId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedLocationId")) {
      selectedLocationId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedLocationId"));
      this.selectedLocationId = selectedLocationId;
    }
    var selectedDepotId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedDepotId")) {
      selectedDepotId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedDepotId"));
      this.selectedDepotId = selectedDepotId;
    }

    var selectedVehicleType = null;
    if (this.sessionStorageService.getItem("dashboard-active-selectedVehicleType")) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }

    this.dashboardMode = this.irregularMovements ? DashboardMode.Irregular : DashboardMode.Normal;
    var params: ActiveDashboardRequest = {
      customerId: this.pageHelperService.selectedCompanyId,
      startDate: moment(selectedStartDate),
      endDate: moment(selectedEndDate),
      blackboxId: selectedVehicleId,
      locationId: selectedLocationId,
      depotId: selectedDepotId,
      onlyShowIrregularInfo: this.irregularMovements,
      returnAllRows: true,
      vehicleType: selectedVehicleType == null ? "" : selectedVehicleType
    };
    return params;
  }

  viewModeChange(e) {
    this.showMode = e.target.value;
    this.inTransitMap.invalidateMap();
  }
}
